module.exports = __webpack_public_path__ + "static/media/logo-1line.8fcf11a2.svg";